// extracted by mini-css-extract-plugin
export default {"root":"link_root__zp1Rq","icon":"link_icon__HU3NN","color-primary":"link_color-primary__utkeU"};